const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m512 23.714h-512v30h15.97v322.473h225.03v37.796c-13.893 5.869-23.667 19.633-23.667 35.638 0 21.321 17.346 38.667 38.667 38.667s38.667-17.346 38.667-38.667c0-16.005-9.774-29.768-23.667-35.638v-37.796h225.03v-322.473h15.97zm-141.65 71.23v30h-299.378v-30zm-95.02 210.012h-204.358v-30h204.358zm0-60.004h-204.358v-30h204.358zm0-60.004h-204.358v-30h204.358zm160.036 120.008h-135.033v-150.008h135.033z",
    fill: "#fffbfb",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.333 184.948h75.033v90.007h-75.033z",
    fill: "#fffbfb",
    "data-original": "#000000",
    style: {}
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject2);
export default __webpack_public_path__ + "static/media/project2.e5dfa42a6cffc6f12d202320c1ffff80.svg";
export { ForwardRef as ReactComponent };